<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    <template v-if="!existingAccount">
      <text-input
        v-model="value.first_name"
        :errors="errors.first_name"
        :label="t('create-user.form.labels.first_name')"
        :placeholder="t('create-user.form.labels.first_name')"
        input-id="first_name"
        required />
      <text-input
        v-model="value.last_name"
        :errors="errors.last_name"
        :label="t('create-user.form.labels.last_name')"
        :placeholder="t('create-user.form.labels.last_name')"
        input-id="last_name"
        required />
    </template>
    <p
      v-else
      class="typeset-9 md:col-span-full">
      {{ t("create-user.form.existing-account.notice") }}
    </p>
    <text-input
      v-model="value.email"
      :errors="errors.email"
      :label="t('create-user.form.labels.email')"
      :placeholder="t('create-user.form.labels.email')"
      input-id="email"
      required
      @blur="$emit('check-email')" />
    <div>
      <text-input
        v-model="value.password"
        :errors="errors.password"
        :label="passwordLabel"
        :placeholder="passwordLabel"
        type="password"
        input-id="password"
        required />
      <a
        v-if="existingAccount"
        :href="forgotPasswordPath"
        class="typeset-8 underline">
        {{ t("create-user.form.existing-account.forgot-password") }}
      </a>
    </div>
    <checkbox-input
      v-if="!existingAccount"
      v-model:checked="value.newsletter"
      :errors="errors.newsletter"
      :label="t('create-user.form.labels.newsletter')"
      class="md:col-span-full"
      input-id="newsletter" />
  </div>
</template>

<script>
import TextInput from "../shared/TextInput.vue";
import CheckboxInput from "../shared/CheckboxInput.vue";

export default {
  name: "CreateUserForm",
  components: {
    TextInput,
    CheckboxInput
  },
  props: {
    errors: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    existingAccount: {
      type: Boolean,
      default: false
    },
    forgotPasswordPath: {
      type: String,
      required: true
    }
  },
  emits: ["check-email"],
  computed: {
    passwordLabel() {
      return this.existingAccount
        ? this.t("create-user.form.existing-account.password")
        : this.t("create-user.form.labels.password");
    }
  }
};
</script>
